import { render } from "./Pemilik.vue?vue&type=template&id=3f44b5b6"
import script from "./Pemilik.vue?vue&type=script&lang=js"
export * from "./Pemilik.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__